import {TemplateDetailsEntry} from './model/template.entry';

export function toFullForm(details: TemplateDetailsEntry) {
  return {
    destinationPosition: details.destination,
    destination: details.destination.address != null && details.destination.address.length > 0
      ? details.destination.address
      : details.destination.lat.toFixed(6) + ', ' + details.destination.lng.toFixed(6),
    waypoints: details.waypoints,
    weight: details.weight,
    axelWeight: details.axleWeight,
    height: details.height,
    width: details.width,
    strategy: details.strategy,
    vehicleType: details.vehicleType,
    avoids: details.avoids,
    comments: details.comment,
    type: details.type,
    traffic: details.traffic
  };
}

export function toPartialForm(details: TemplateDetailsEntry) {
  return {
    waypoints: details.waypoints,
    weight: details.weight,
    axelWeight: details.axleWeight,
    height: details.height,
    width: details.width,
    strategy: details.strategy,
    vehicleType: details.vehicleType,
    avoids: details.avoids,
    traffic: details.traffic
  };
}
